import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import Links from '@/shared/constants/navegacao';
import { useEffect } from 'react';
import { BiArrowBack } from 'react-icons/bi';

export function useVoltarAuditorias() {
  const { setActions } = useBreadcrumbActions();

  useEffect(() => {
    setActions({
      primary: {
        label: 'Voltar para Auditorias',
        onClick: () => {},
        href: Links.Auditorias_Index,
        icon: BiArrowBack,
      },
    });
    return () => setActions({});
  }, [setActions]);
}
